export default {
    name: "End",
    title: "End",
    icon: "mdi-stop-circle-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
        };
    },
};